export default __webpack_public_path__ + "static/media/closeIcon.49d597c1.svg";